const Register = () => import('@/views/Register')

export default [
  {
    path: '/register',
    component: Register
  }
]
